/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class BeforeAfter {
      constructor(enteryObject) {
  
          const beforeAfterContainer = document.querySelector(enteryObject.id);
          const before = beforeAfterContainer.querySelector('.bal-before');
          const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
          const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
          const handle = beforeAfterContainer.querySelector('.bal-handle');
          var widthChange = 0;
  
          beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
          window.onresize = function () {
              beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
          }
          before.setAttribute('style', "width: 50%;");
          handle.setAttribute('style', "left: 50%;");
  
          //touch screen event listener
          beforeAfterContainer.addEventListener("touchstart", (e) => {
  
              beforeAfterContainer.addEventListener("touchmove", (e2) => {
                  let containerWidth = beforeAfterContainer.offsetWidth;
                  let currentPoint = e2.changedTouches[0].clientX;
  
                  let startOfDiv = beforeAfterContainer.offsetLeft;
  
                  let modifiedCurrentPoint = currentPoint - startOfDiv;
  
                  if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                      let newWidth = modifiedCurrentPoint * 100 / containerWidth;
  
                      before.setAttribute('style', "width:" + newWidth + "%;");
                      afterText.setAttribute('style', "z-index: 1;");
                      handle.setAttribute('style', "left:" + newWidth + "%;");
                  }
              });
          });
  
          //mouse move event listener
          beforeAfterContainer.addEventListener('mousemove', (e) => {
              let containerWidth = beforeAfterContainer.offsetWidth;
              widthChange = e.offsetX;
              let newWidth = widthChange * 100 / containerWidth;
  
              if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                  before.setAttribute('style', "width:" + newWidth + "%;");
                  afterText.setAttribute('style', "z-index:" + "1;");
                  handle.setAttribute('style', "left:" + newWidth + "%;");
              }
          })
  
      }
  }

  var balItems = document.querySelectorAll('.bal-container');
  balItems.forEach(function(item){
    var id = item.getAttribute('id');
    new BeforeAfter({
      id: '#' + id
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function(event) {
  var beforeAfterImagesSections = document.querySelectorAll('.hair-product-before-after-images');
  var beforeAfterImagesSectionsButtons = document.querySelectorAll('.hair-product-before-after-images .action-button');
  if (beforeAfterImagesSections.length && beforeAfterImagesSectionsButtons.length) {
    beforeAfterImagesSectionsButtons.forEach(function(item){
      item.addEventListener("mouseup", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.remove('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.remove('show-after-img');
          });
        }
      });

      item.addEventListener("mousedown", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.add('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.add('show-after-img');
          });
        }
      });

      item.addEventListener("touchend", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.remove('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.remove('show-after-img');
          });
        }
      });

      item.addEventListener("touchstart", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.add('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.add('show-after-img');
          });
        }
      });
    })
  }

  document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('custom_video__share_icon') || el.closest('.custom_video__share_icon')) {
      if(!el.classList.contains('custom_video__share_icon')) {
      	el = el.closest('.custom_video__share_icon');
      }
      
      e.preventDefault();
    let url = window.location.origin + window.location.pathname  + '#video';

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      
        navigator.share({
    title: '',
    text: '',
    url: url
  });
        } else {
        navigator.clipboard.writeText(url);   
      
      el.classList.add('copied');
      setTimeout(function () {
         el.classList.remove('copied');
      },2000);
        }
    }
  });

  

  
});
window.onload = function(e){ 
     if(window.location.href.indexOf('#video') >= 0) {
       window.history.pushState({}, document.title, window.location.pathname ); 
    }
};

$(document).ready(function () {
  var topPromoSection = $('.top-promo-section');
  var mainHeader = $('#shopify-section-header');
  var announcementBar = $('#shopify-section-announcement');
  var topPromoSectionDelay = topPromoSection.attr('data-delay') * 1000;
  var topPromoSectionHeight;
  var announcementBarHeight;
  var date = new Date();
  var announcementBarIsSticky = false;

  if ($('.announcement__wrapper').attr('data-sticky') == 'true') {
    announcementBar.css('position', 'sticky');
    announcementBar.css('top', '0');
    announcementBarIsSticky = true;
    mainHeader.css('top', announcementBar.outerHeight() + 'px');
    document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + 50)  + "px");
    }

  if (topPromoSectionDelay == 0) {
    topPromoSectionDelay = 500;
  }

  if (date.getTime() >= +localStorage.getItem("showTopPromoSectionTime")) {
    localStorage.removeItem("showTopPromoSectionTime");
    localStorage.removeItem("hiddenTopPromoSection");
  }
 
  if (localStorage.getItem("hiddenTopPromoSection") != 'true') {
    setTimeout(function () {
      var copied_elem = topPromoSection.clone().css({visibility:"hidden", display:"block", position:"absolute"});
      $("body").append(copied_elem);
      topPromoSectionHeight = copied_elem.outerHeight();
      copied_elem.remove();
      console.log(topPromoSectionHeight)
      announcementBarHeight = announcementBar.outerHeight();
      announcementBar.css('top', topPromoSectionHeight + 'px');
      document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + topPromoSectionHeight + 50)  + "px");
      if (announcementBarIsSticky) {        
        mainHeader.css('top', topPromoSectionHeight + announcementBarHeight + 'px');
      } else {
        mainHeader.css('top', topPromoSectionHeight + 'px');
      }
      topPromoSection.slideDown(300);
      topPromoSection.addClass('is-open');
    }, topPromoSectionDelay);
  }

  $(window).resize(function() {
    if (topPromoSection.hasClass('is-open')) {
      announcementBar.css('top', topPromoSection.outerHeight() + 'px');
      document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + topPromoSection.outerHeight() + 50)  + "px");

      if (announcementBarIsSticky) {
        mainHeader.css('top', topPromoSection.outerHeight() + announcementBar.outerHeight() + 'px');
      } else {
        mainHeader.css('top', topPromoSection.outerHeight() + 'px');
      }
    }
  });

  $('.top-promo-section .top-promo-section-close').on('click', function() {
    $('.top-promo-section').slideUp(300);
    $('.top-promo-section').removeClass('is-open');
    document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + 50)  + "px");
    announcementBar.css('top', '0');
    if (announcementBarIsSticky) {
      mainHeader.css('top', announcementBar.outerHeight() + 'px');
    } else {
      mainHeader.css('top', '0');
    }
    var dateToShow = date.getTime() + 1000 * 60 * 60 * 24;
    localStorage.setItem("hiddenTopPromoSection", "true");
    localStorage.setItem("showTopPromoSectionTime", dateToShow);
  });
});



document.addEventListener('click', function(e) {
  var el = e.target;
  if(el.closest('.custom-dropdown-wrapper')) {

    if(!el.classList.contains('main-field')) {
      el = el.closest('.main-field');
    }

    var customDropdownWrapper = el;

    if(customDropdownWrapper) {
      if(!customDropdownWrapper.classList.contains('custom-dropdown')) {
        customDropdownWrapper = customDropdownWrapper.closest('.custom-dropdown');
      }

      var customDropdown = customDropdownWrapper.querySelector('.main-field');





      var customDropdownList = el.nextElementSibling;      
      var bounding = customDropdown.getBoundingClientRect();
      var dropdownFromTop = bounding.top;

      if (customDropdownList != null) {
        if (customDropdownList.classList.contains('open')) {
          customDropdownList.classList.remove("open");
          customDropdown.classList.remove("top-list");
          customDropdown.classList.remove("bottom-list");
        } else {
          customDropdownList.classList.add("open");
          customDropdown.classList.add("bottom-list");
        }
      }
    }
  } else {
    if (document.querySelector('.custom-dropdown-list') != null && document.querySelector('.main-field') != null) {
      document.querySelector('.custom-dropdown-list').classList.remove("open");
      document.querySelector('.main-field').classList.remove("top-list");
      document.querySelector('.main-field').classList.remove("bottom-list");
    }
  }

});

document.addEventListener('click', function(e) {

  var el = e.target;
  if(el.classList.contains('custom-dropdown-list-item') || el.closest('.custom-dropdown-list-item')) {
    if(!el.classList.contains('custom-dropdown-list-item')) {
      el = el.closest('.custom-dropdown-list-item');
    }

    var elementParent = el.parentElement;
    var dropdownWrapper = elementParent.previousElementSibling;
    var elementContent = el.innerHTML;


    //var optionsSelect = document.querySelector('.single-option-selector');

    var optionValue = el.querySelector("span").innerHTML;
    if(elementParent.querySelector('.custom-dropdown-list-item.selected')) {
      elementParent.querySelector('.custom-dropdown-list-item.selected').classList.remove("selected");
    }
    el.classList.add("selected");
    dropdownWrapper.classList.remove("top-list");
    dropdownWrapper.classList.remove("bottom-list");
    elementParent.classList.remove("open");
    dropdownWrapper.innerHTML = elementContent;


    var color_value = el.getAttribute('data-color-value');
    console.log(el);
    console.log(1);
    var ColorSwatch__Radio_arr = el.closest('.selector-wrapper').querySelectorAll('[data-single-option-selector]');
    for(var i=0;i < ColorSwatch__Radio_arr.length;i++) {
      var ColorSwatch__Radio = ColorSwatch__Radio_arr[i];
      var val = ColorSwatch__Radio.getAttribute('data-value');
      if(val == color_value) {
        ColorSwatch__Radio.click();
        break;
      }
    }
  }

});

$(document).ready(function() {
  if ($(window).width() < 750) {
   $('.product-form-fields-wrapper').addClass('is-fixed');
  }
  // $(window).scroll(function(event) {
  //   if ($(window).width() < 750) {
  //     if ($('.product-form-fields-wrapper-container').offset().top + $('.product__submit__buttons .product__submit__add[type="submit"]').outerHeight() < $(window).scrollTop() + $('#shopify-section-top-promo').outerHeight() + $('#shopify-section-announcement').outerHeight() + $('#shopify-section-header').outerHeight()) {
  //       $('.product-form-fields-wrapper').addClass('is-fixed');
  //     } else {
  //       $('.product-form-fields-wrapper').removeClass('is-fixed');
  //     }
  //   }
  // });

  $('.product-item .product-information').matchHeight();
});


    if ($(window).width() < 750) {
    // Function to check the scroll position and add/remove class
    function checkScroll() {
        var scrollPosition = $(window).scrollTop();
        var elementOffset = $('.custom-location-sho-pay').offset().top;
        var distance = elementOffset - 50; // 50px below the element

        if (scrollPosition > distance) {
            $('.product-form-fields-wrapper').addClass('is-fixed');
        } else {
            $('.product-form-fields-wrapper').removeClass('is-fixed');
        }
    }

    // Attach the function to the window scroll event
    $(window).scroll(checkScroll);
    };
